import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INotification } from '@app/notification-module/interfaces/notification.interface';
import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribableComponent } from '@app/shared/unsubscribable/unsubscribable.component';
import { NOTIFICATION_TYPE } from '@app/notification-module/enums/notification-type.enum';

@Component({
  standalone: false,
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent extends UnsubscribableComponent implements OnInit {
  @Input() notification: INotification = null;
  @Output() remove: EventEmitter<INotification> = new EventEmitter<INotification>();
  public isSuccess: boolean;
  public isError: boolean;
  public isInfo: boolean;
  public iconName: string;
  private _defaultDuration = 4000;

  constructor() {
    super();
  }

  ngOnInit() {
    timer(this._defaultDuration)
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => this.removeNotification());

    this.isSuccess = this.notification.type === NOTIFICATION_TYPE.SUCCESS;
    this.isError = this.notification.type === NOTIFICATION_TYPE.ERROR;
    this.isInfo = this.notification.type === NOTIFICATION_TYPE.INFO;
    this.iconName = this.getIconName();
  }

  public removeNotification(): void {
    this.remove.emit(this.notification)
  }

  public getIconName(): string {
    if (this.isSuccess) {
      return 'check';
    }

    if (this.isError) {
      return 'alert-triangle';
    }

    return 'alert-circle';
  }
}
